import { ThemeOptions } from '@mui/material/styles';

export const lightBaseThemeOptions: ThemeOptions = {
  shape: {
    drawerRadius: '0.75rem',
    buttonRadius: {
      large: '0.5rem',
      medium: '0.375rem',
      small: '0.375rem',
      extraSmall: '0.25rem',
    },
    buttonHeight: {
      large: '2.75rem',
      medium: '2.5rem',
      small: '2.25rem',
      extraSmall: '2rem',
    },
    cardRadius: '0.5rem',
    inputRadius: {
      medium: '0.375rem',
      small: '0.25rem',
    },
    inputHeight: {
      medium: '2.5rem',
      small: '2rem',
    },
    modalRadius: '0.75rem',
    menuRadius: '0.5rem',
    menuAnchorRadius: '0.125rem',
    tagRadius: '0.375rem',
    toastRadius: '0.5rem',
    tooltipRadius: '0.25rem',
    tooltipArrowRadius: '0.125rem',
    avatarRadius: '0.375rem',
    containerRadius: '0.5rem',
    chipRadius: '0.75rem',
    mapPinRadius: '999px',
  },
};
